module.exports = __webpack_public_path__ + "img/affiliate-mgmt.d9e98fee.svg";